// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Pc","contentWrapCtaDefault":"Qc","disabled":"Rc","contentWrapCtaWhite":"Sc","promos":"Tc","lazyPromo":"Uc","mainContent":"Vc","headingText":"Wc","copy":"Xc","subtext":"Yc"};